import React from "react";
import "./CheckoutInfo.css";
// import axios from "axios";
// import queryString from "query-string";

export default class CheckoutInfo extends React.Component {
  state = {
    cart: {
      items: [],
    },
    cartTotal: 0,
  };
  componentDidMount() {
    //GET CHECKOUT INFO
    this.setState({ cart: this.props.cart });
    this.setState({ cartTotal: this.props.cartTotal });
  }

  parceStripePrice(price, currency) {
    let priceParsed =
      price.toString().substring(0, price.toString().length - 2) +
      "." +
      price
        .toString()
        .substring(price.toString().length - 2, price.toString().length) +
      " " +
      currency;
    return priceParsed;
  }

  render() {
    return (
      <div className="checkout_info_bubble">
        {this.props.cart.items.map((cartItem) => (
          <div className="cartItem" key={cartItem.name}>
            <div className="cartItemName">
              {cartItem.name}
              <div className="cartItemInfo">{cartItem.itemDescription}</div>
            </div>

            <div className="cartItemPrice">
              {this.parceStripePrice(
                cartItem.price,
                this.props.cart.currencySymbol
              )}
            </div>
          </div>
        ))}
        <div className="cartItem cartTotal" key="cartTotal">
          <div className="cartItemName">
            <b>CART TOTAL</b>
          </div>

          <div className="cartItemPrice">
            <b>
              {this.parceStripePrice(
                this.props.cartTotal,
                this.props.cart.currencySymbol
              )}
            </b>
          </div>
        </div>
      </div>
    );
  }
}
